import { DetailData } from "@ud/api/newPhpApi/__generated__/newPhpApi.generated";
import { TFilter } from "scenes/Search/types";

export const getOfferType = (
  offerTypeId?: DetailData["offerTypeId"],
): TFilter["offerType"] => {
  if (offerTypeId === "sale") {
    return "sale";
  }
  if (offerTypeId === "coliving") {
    return "coliving";
  }

  return "rent";
};
